import { useCallback, useEffect, useState } from "react"
import PantallaCargando from "../../general/pantalla_cargando"
import { toast } from "react-toastify"
import { useDispatch, useSelector } from "react-redux"
import { cerrarSesion } from "../../../redux/actions/session"
import { urlapi } from "../../../lib/backend/data"
import { debounce } from "@mui/material"
import { url_images } from "../../../lib/global/data"
import { MdOutlineSecurity } from "react-icons/md"
import { Badge, Button, ButtonGroup, Card, Col, Row, Spinner } from "react-bootstrap"
import { formatoMoneda } from "../../../lib/helpers/main"
import { FaCheckCircle, FaRegClock } from "react-icons/fa";
import ErrorBoundary from "../../errorsHandler/errorBoundary"
import Moment from "react-moment"
import Skeleton from "react-loading-skeleton"
import { IoIosRadioButtonOff, IoMdRadioButtonOn } from "react-icons/io"

const UberActivar = (props) => {
    const {
        code,
        selected,
        geo_datos,
        id_orden,
        typeView,
        autoQuote
    } = props
    const components = {
        resumen: ''
    }
    const estructura = {
        key: "",
    }
    const [ id, setId ] = useState("")
    const [ estructuraActual, setEstructuraActual ] = useState({
        detalles: estructura
    })
    const [ quote, setQuote ] = useState(null)
    const [ error, setError ] = useState(null)
    const [ errorObject, setErrorObject ] = useState(null)
    const [ loading, setLoading ] = useState(false)
    const sitio = useSelector(state => state.sitio)
    const [ tarifas, setTarifas ] = useState([])
    const [ confirmData, setConfirmData ] = useState(null)
    const [ confirmando, setConfirmando ] = useState(false)
    const [ pendienteGuardar, setPendienteGuardar ] = useState(false)
    const [ cotizando, setCotizando ] = useState(false)

    const [ loadingGuardado, setLoadingGuardado ] = useState(false)

    const dispatch = useDispatch()

    useEffect(() => {
        obtenerDatos("uber")
    }, [])

    const obtenerDatosOrden = async (structure)=>{
        setConfirmando(true)
        return fetch(`${urlapi}/uber/order`,{
            method:'POST',
            body: JSON.stringify({ id_orden }),
            headers: {
                'Content-Type':'application/json',
            }
        })
        .then(res => {
            if(res.status === 401) return dispatch(cerrarSesion())
            return res.json()
        })
        .then(res => {
            if(!res){
            } else if(res.errorMessage){
                setError(res.errorMessage)
            } else if(res.message){
                setError(res.message)
            } else if(res._id){
                setConfirmData(res)
            } else {
                if(structure?.detalles?.id_customer && structure?.detalles?.secret && structure?.detalles?.origen && autoQuote) cotizarUber() 
            }
            return setConfirmando(false)
        })
        .catch(error => {
            return setConfirmando(false)
        })
    }

    const obtenerDatos = async (modulo)=>{
        setLoading(true)
        return fetch(`${urlapi}/configuracion?tipo=credenciales&subtipo=${modulo}`,{
            method:'GET',
            headers: {
                'Content-Type':'application/json',
            }
        })
        .then(res => {
            if(res.status === 401) return dispatch(cerrarSesion())
            return res.json()
        })
        .then(res => {
            if(!res){
            } else if(res.errorMessage){
                setError(res.errorMessage)
            } else if(res._id){
                setId(res._id)
                setEstructuraActual(res)
                if(res?.detalles?.id_customer && res?.detalles?.secret || res?.detalles?.origen) return cotizarUber()

            }
            return setLoading(false)
        })
        .catch(error => {
            return setLoading(false)
        })
    }

    const cotizarUber = async ()=>{
        setCotizando(true)
        return fetch(`${urlapi}/uber/quote?id=${id_orden}`,{
            method:'POST',
            body: JSON.stringify({
                geo_datos,
                propietario: sitio?.propietario
            }),
            headers: {
                'Content-Type':'application/json',
            }
        })
        .then(res => {
            if(res.status === 401) return dispatch(cerrarSesion())
            return res.json()
        })
        .then(res => {
            if(!res){
            } else if(res.errorMessage){
                setError(res.errorMessage)
            } else if(Array.isArray(res)){
                if(res.length > 0){
                    setTarifas(res)
                    // setQuote(res)
                }
            }
            setLoading(false)
            return setCotizando(false)
        })
        .catch(error => {
            setLoading(false)
            return setCotizando(false)
        })
    }

    const confirmar = async (payload)=>{
        const {
            canal
        } = payload
        setConfirmando(true)
        return fetch(`${urlapi}/${canal}/confirm?id=${id_orden}`,{
            method:'POST',
            body: JSON.stringify({ ...payload }),
            headers: {
                'Content-Type':'application/json',
            }
        })
        .then(res => {
            if(res.status === 401) return dispatch(cerrarSesion())
            return res.json()
        })
        .then(res => {
            if(!res){
            } else if(res.errorMessage){
                setError(res.errorMessage)
            } else if(res.message){
                setError(res.message)
                if(res.metadata) setErrorObject(res)
            } else if(res?._id){
                if(props.onConfirm) props.onConfirm()
                setConfirmData(res)
            }
            return setConfirmando(false)
        })
        .catch(error => {
            console.log(error.message)
            return setConfirmando(false)
        })
    }
    
    const guardarAutomatico = async (payload)=>{
        setLoadingGuardado(true)
        return fetch(`${urlapi}/configuracion/personalizar`,{
            method:'PUT',
            body: JSON.stringify(payload),
            headers: {
                'Content-Type':'application/json',
            }
        })
        .then(res => {
            if(res.status === 401) return dispatch(cerrarSesion())
            return res.json()
        })
        .then(res => {
            if(!res){
            } else if(res.errorMessage){
                setError(res.errorMessage)
            }
            setPendienteGuardar(false)
            return setLoadingGuardado(false)
        })
        .catch(error => {
            setPendienteGuardar(false)
            return setLoadingGuardado(false)
        })
    }
    
    const handleChangeExtra = (e, type, campo) => {
        const valor = e.target.value
        if(type === "modulo"){
            const i = estructuraActual.modulos.findIndex(modulo => modulo.slug === campo)
            if( i > -1 ){
                 setPendienteGuardar(true)
                 return setEstructuraActual(prev => {
                    let actual = {...prev}
                    actual.modulos[i].extra = valor
                    actualizar({ _id: id, detalles: actual })
                    return { ...actual }
                 })
            }
        }
    }

    const actualizar = useCallback(debounce((data) => guardarAutomatico(data), 1000), []);

    const handleCheck = (e, type, campo) => {
        const valor = e.target.checked
        if(type === "modulo"){
            const i = estructuraActual.modulos.findIndex(modulo => modulo.slug === campo)
            if( i > -1 ){
                if(estructuraActual.modulos[i].onlyRead === true) return false
                 return setEstructuraActual(prev => {
                    let actual = {...prev}
                    actual.modulos[i].activo = valor
                    actualizar({ _id: id, detalles: actual })
                    return { ...actual }
                 })
            }
        } else if(type === "campos"){
            const i_ = estructuraActual.campos.findIndex(ca => ca.slug === campo)
            if( i_ > -1 ){
                 return setEstructuraActual(prev => {
                    let actual = {...prev}
                    actual.campos[i_].activo = valor
                    actualizar({ _id: id, detalles: actual })
                    return { ...actual }
                 })
            }
        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target
        return setEstructuraActual(prev => {
            let actual = {...prev}
            if(!actual.detalles) actual.detalles = {}
            actual.detalles[name] = value
            actualizar(actual)
            return { ...actual }
        })
    }

    const confirmDataMessage = (type) => {

        if(type === "line") return <Card className="p-2 text-left"><Row>
            <Col xs={1}><img src={`${url_images}/uber.png`} style={{ width: "100%" }} /></Col>
            <Col xs={10}>
            <h6 className="mb-0">CÓDIGO DE CONFIRMACIÓN</h6>
            <Badge variant="dark">{confirmData?.value}</Badge>
            </Col>
        </Row></Card>

        return <div>
            <h4><FaCheckCircle color="green" /> Servicio confirmado</h4>
            <h6 className="mb-0">CÓDIGO DE CONFIRMACIÓN</h6>
            <Badge variant="dark">{confirmData?.value}</Badge>
        </div>
    }

    const seleccionarTarifa = (e) => {
        if(props.onSelect) props.onSelect({
            code: "uber",
            canal: "uber", key: "uber-order-id",
            ...e,
            fee: (e?.fee / 100)
        })
    }

    const mostrarInformacionLinea = () => {
                const col_logo = <Col xs={2}>{ selected?.code === code ? <IoMdRadioButtonOn /> : <IoIosRadioButtonOff />} <img src={`${url_images}/uber.png`} style={{ width: "60%" }} /></Col>
        
                const cargando = <Card className="p-2">
                    <Row className="justify-content-center align-items-center">
                        {col_logo}
                        <Col xs={10}><Skeleton count={2} /> </Col>
                    </Row></Card>
        
                if(confirmando || loading) return cargando

                if(!estructuraActual?.detalles?.id_customer || !estructuraActual?.detalles?.secret || !estructuraActual?.detalles?.origen) return false

                return <div>
                    {
                        tarifas.map((tarifa, i) => {
                            return <Card md={6} key={`tarifa-${i}`} className="p-2 hover" onClick={() => seleccionarTarifa(tarifa)} style={{ border: selected?.code === code ? "1px solid black" : "none" }}>
                                <Row className="justify-content-center align-items-center">
                                {col_logo}
                                        <Col xs={4} className="text-left"><p className="mb-0">Envío express</p></Col>
                                        {/* <Col xs={4}><Badge variant="primary" style={{ fontSize: 11 }} className="text-uppercase w-100"><FaRegClock /> Vence <Moment fromNow>{tarifa.expires}</Moment> </Badge></Col> */}
                                        <Col xs={2}><Badge className="w-100" variant="dark">{tarifa.duration+25} Mins.</Badge></Col>
                                        <Col xs={4} className="text-right" ><h5 className="mb-0">CLP {formatoMoneda(tarifa?.fee / 100)}</h5>
                                        
                                        </Col>
                                    </Row>
                                    
                                </Card>
                        })
                    }
                </div>
    }

    const mostrarInformacion = () => {
        if(confirmando) return <div className="d-block text-center"><Spinner animation="border" /></div>
        if(confirmData) return  confirmDataMessage()

        if(!estructuraActual?.detalles?.id_customer || !estructuraActual?.detalles?.secret || !estructuraActual?.detalles?.origen) return false

        return <div>
            <ButtonGroup className="mb-3">
            <Button size="sm" disabled={cotizando} variant="light" onClick={() => cotizarUber()}>{ cotizando ? "BUSCANDO..." : "BUSCAR VEHÍCULO"}</Button>
            {/* <Button size="sm" disabled={cotizando} variant="primary" >CONFIRMAR</Button> */}
            </ButtonGroup>
            { tarifas.length > 0 ? <div>
                <h4>Tarifas encontradas <Badge variant="dark">{formatoMoneda(tarifas.length)}</Badge></h4>
            </div> : false }
            {
                tarifas.map((tarifa, i) => {
                    return <Card md={6} key={`tarifa-${i}`} className="p-2">
                            <Row>
                                <Col xs={9}><Badge className="w-100" variant="primary" style={{ textTransform: "uppercase" }}>ID {tarifa.id}</Badge></Col>
                                <Col xs={3}><Badge className="w-100" variant="dark">{tarifa.duration} Mins.</Badge></Col>
                            </Row>
                            <Row className="mt-3">
                                <Col className="text-left" >
                                <h4 className="mb-0">CLP {formatoMoneda(tarifa?.fee / 100)}</h4>
                                <Badge variant="dark" style={{ fontSize: 11 }} className="text-uppercase"><FaRegClock /> Vence <Moment fromNow>{tarifa.expires}</Moment> </Badge></Col>
                                <Col className="text-right" ><Button disabled={confirmando} size="sm" variant="light" onClick={() => confirmar({ ...tarifa, id_orden, canal: "uber", key: "uber-order-id" })}>CONFIRMAR</Button></Col>
                            </Row>
                            
                        </Card>
                })
            }
        </div>
    }

    
    if(typeView === "line") return mostrarInformacionLinea()
    
    if(loading) return <PantallaCargando />


    return <div>
        {/* <img src={`${url_images}/uber.png`} style={{ height: 50, marginBottom: 10 }} /> */}
        {mostrarInformacion()}
        <ErrorBoundary message={error} jsonData={errorObject} />
    </div>
}

export default UberActivar